import React, { useEffect } from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { useTranslation } from 'react-i18next';

const invoicesSearchHeadCells = [
  { id: '', numeric: false, label: '' },
  { id: 'invoiceNumber', numeric: false, label: 'Invoice number' },
  { id: 'supplier', numeric: false, label: 'Supplier' },
  { id: 'activityType', numeric: false, label: 'Activity type' },
  { id: 'invoiceDate', numeric: false, label: 'Invoice date' },
  { id: 'wagonNumber', numeric: true, label: 'Wagon number' },
  { id: 'attachmentName', numeric: false, label: 'Invoice document' },
  { id: 'eventDate', numeric: false, label: 'Event date' },
  { id: 'amount', numeric: true, label: 'Amount (€)' },
  { id: 'maintenanceTicketNumber', numeric: false, label: 'Ticket number' },
  { id: 'ticketCreationDate', numeric: false, label: 'Ticket date' },
];
const ticketDetailsPageHeadCells = [
  { id: 'invoiceNumber', numeric: false, label: 'Invoice number' },
  { id: 'supplier', numeric: false, label: 'Supplier' },
  { id: 'activityType', numeric: false, label: 'Activity type' },
  { id: 'invoiceDate', numeric: false, label: 'Invoice date' },
  { id: 'attachmentName', numeric: false, label: 'Invoice document' },
  { id: 'eventDate', numeric: false, label: 'Event date' },
  { id: 'amount', numeric: true, label: 'Amount (€)' },
];
const wagonDetailsPageHeadCells = [
  { id: 'maintenanceTicketNumber', numeric: false, label: 'Ticket ID' },
  { id: 'invoiceNumber', numeric: false, label: 'Invoice number' },
  { id: 'supplier', numeric: false, label: 'Supplier' },
  { id: 'activityType', numeric: false, label: 'Activity type' },
  { id: 'invoiceDate', numeric: false, label: 'Invoice date' },
  { id: 'attachmentName', numeric: false, label: 'Invoice document' },
  { id: 'eventDate', numeric: false, label: 'Event date' },
  { id: 'amount', numeric: true, label: 'Amount (€)' },
];
export default function InvoiceListHead(props) {
  const {
    classes,
    wagonDetailsPage,
    ticketDetailsPage,
    order,
    orderBy,
    onRequestSort,
  } = props;
  const [selectAll, setSelectAll] = React.useState(false);
  const [headCells, setHeadCells] = React.useState(invoicesSearchHeadCells);
  const { t } = useTranslation();

  useEffect(() => {
    if (ticketDetailsPage) {
      setHeadCells(ticketDetailsPageHeadCells);
    }
    if (wagonDetailsPage) {
      setHeadCells(wagonDetailsPageHeadCells);
    }
  }, [ticketDetailsPage, wagonDetailsPage]);

  function selectAllInvoices(value) {
    setSelectAll(value);
    props.selectAll(value);
  }

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            className={classes.tableHead}
            align="left"
          >
            {headCell.id === '' ? (
              <Checkbox
                data-testid="select-checkbox"
                className={
                  selectAll ? classes.checkboxSelected : classes.checkbox
                }
                checked={selectAll || false}
                onChange={(event) => selectAllInvoices(event.target.checked)}
                inputProps={{ 'aria-label': 'select-checkbox' }}
              />
            ) : (
              <TableSortLabel
                data-testid="sort"
                classes={{
                  icon: orderBy === headCell.id ? classes.arrowSorting : null,
                }}
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {t(headCell.label)}
              </TableSortLabel>
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
